// ESM shim – resolved by the Vite alias for `'jquery'`.
// Used in DEV mode (esbuild serves this file directly to ESM source imports).
// In PRODUCTION, the jqueryRolldownPlugin in vite.config.shared.js intercepts
// this path and returns a CJS virtual module instead, so CJS consumers
// (slick, datetimepicker, …) receive window.jQuery directly.
if (typeof window === 'undefined' || !window.jQuery) {
    throw new Error(
        'jQuery is missing on window. Ensure <script src="{{ asset(\'js/jquery.min.js\') }}"></script> ' +
        'is included in the layout <head> before @vite(...).'
    );
}
const $ = window.jQuery;
export default $;
export const jQuery = $;
export { $ as "module.exports" };
export const trim = $.trim || function (s) {
    return String(s == null ? '' : s).replace(/^\s+|\s+$/g, '');
};
